import type { IdentityV1 } from '@alpod-ai-writer/backend';
import { create } from 'zustand';

interface AuthState {
    identity: IdentityV1.OwnRecord | null;
    isAccessDenied: boolean;
    setIdentity: (identity: IdentityV1.OwnRecord) => void;
    setAccessDenied: () => void;
    clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    identity: null,
    isAccessDenied: false,
    setIdentity: (identity) => set({ identity, isAccessDenied: false }),
    setAccessDenied: () => set({ identity: null, isAccessDenied: true }),
    clear: () => set({ identity: null, isAccessDenied: false }),
}));
